import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { MessagesService } from '@modules/messages/services'
import { AccountService } from '@services/account.service'
import { AccountProduct, AccountProductType } from '@models/account.model'
import { Events } from '@services/events'

@Component({
	selector: 'sbpro-top-nav-messages',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './top-nav-messages.component.html',
	styleUrls: ['top-nav-messages.component.scss'],
	standalone: false
})
export class TopNavMessagesComponent implements OnInit, OnDestroy {
	@Input() placement = 'bottom-end'

	private readonly accountService = inject(AccountService)
	private readonly events = inject(Events)
	private productChanged?: Subscription

	constructor(public messagingService: MessagesService) {}

	async ngOnInit() {
		// Ao trocar para o produto do visitante, o socket de avisos do chat fecha (spec 048).
		this.productChanged = this.events.on<AccountProduct>('productChanged').subscribe(product => {
			if (product?.type === AccountProductType.VIS) {
				this.messagingService.disconnectChatNotifications()
			}
		})

		// No produto do visitante não há push nem avisos do chat: o servidor nega a assinatura de
		// `/topic/chat.notifications.{userId}`, e o frame de erro derrubaria a conexão a cada 5 s.
		if (this.accountService.currentProductVisitor) {
			return
		}

		await this.messagingService.registerPushNotifications()
		this.messagingService.receiveMessages()
		this.messagingService.listenChatNotifications()
	}

	async ngOnDestroy() {
		this.productChanged?.unsubscribe()
		await this.messagingService.disconnectChatNotifications()
	}
}
